<template>
  <v-dialog persistent v-model="dialog" width="60%">
    <v-card class="px-2">
      <v-container>
        <!-- header info -->
        <v-row class="px-4 pt-4" v-if="rebooking === ''">
          <h3>New rebooking</h3>
        </v-row>
        <v-row class="px-4 pt-4" v-else>
          <span>
            <h3>Update rebooking {{ rebooking }}</h3>
          </span>
          <v-spacer></v-spacer>
          <span class="ml-6 mt-1">
            <attm_button
              :attachments="attachments"
              :encrid="hombData.homb_encrid"
              entity="homb"
              :entitykey="rebooking"
              @updateData="updateAttachments"
            />
          </span>
        </v-row>
        <v-row dense class="px-2">
          <span style="font-size: small;">
            Duration <b>{{ hombData.homb_normal_days }}</b> days, business days <b>{{ hombData.homb_business_days }}</b>
          </span>
        </v-row>
        <v-row>
          <v-divider></v-divider>
        </v-row>
        <v-row class="pt-3 px-3">      
            <v-col cols="8">
              <div style="display: flex; flex-direction: column;">
                <div style="display: flex; flex-direction: row;">
                  <div style="width: 50%; padding-right: 10px;">
                    <select_initiator :selected_initiator="hombData.homb_initiatief" field="homb_initiatief" :isClearable="true" @updateData="updateData"/>    
                  </div>  
                  <div style="width: 50%; padding-left: 10px;">
                    <select_gebr :selected_gebr="hombData.homb_gebr" field="homb_gebr" label="Assigned to" :isClearable="true" @updateData="updateData"/>    
                  </div>  
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 50%; padding-right: 10px;">
                      <v-select
                        v-model="hombData.homb_omboeking_reden_code"
                        :items="selections.homb_reason_codes"
                        item-value="code"
                        item-text="description"
                        :isClearable="true"
                        @change="updateReasonCode"
                        label="Rebooking reason"
                      />
                    </div>
                    <div style="width: 50%; padding-left: 10px;" v-if="!showExtraDropdown" />
                    <div style="width: 50%; padding-left: 10px;" v-if="showExtraDropdown">
                      <v-select
                        v-if="errorHostForceMajeure"
                        v-model="hombData.homb_omboeking_subreden_code"
                        :items="selections.errorHostForceMajeure"
                        item-value="code"
                        item-text="description"
                        :isClearable="true"
                        label="Host error - Force majeure"
                        @change="updateData"
                      />
                      <v-select
                        v-if="techProblemConnection"
                        v-model="hombData.homb_omboeking_subreden_code"
                        :items="selections.techProblemConnection"
                        item-value="code"
                        item-text="description"
                        :isClearable="true"
                        label="Technical issue connection"
                        @change="updateData"
                      />        
                      <v-select
                        v-if="errorHostNoForceMajeure"
                        v-model="hombData.homb_omboeking_subreden_code"
                        :items="selections.errorHostNoForceMajeure"
                        item-value="code"
                        item-text="description"
                        :isClearable="true"
                        label="Host error - Not force majeure"
                        @change="updateData"
                      />        
                      <v-select
                        v-if="errorExpert"
                        v-model="hombData.homb_omboeking_subreden_code"
                        :items="selections.errorExpert"
                        item-value="code"
                        item-text="description"
                        :isClearable="true"
                        label="Rental expert error"
                        @change="updateData"
                      />                                                  
                    </div>                                     
                </div>                
              </div>
            </v-col>     
            <v-col cols="4" class="">
              <div style="display: flex; flex-direction: column;">
                  <v-checkbox dense hide-details v-model="hombData.homb_ext_alternatief" label="External Alternative"></v-checkbox>
                  <v-checkbox dense hide-details v-model="hombData.homb_ext_alternatief_betaling" label="Extra payment guest for alternative"></v-checkbox>
              </div> 
            </v-col>  
        </v-row>        
        <!-- <v-row class="mt-3"> -->
          <!-- <v-divider class="mt-3"></v-divider> -->
        <!-- </v-row> -->

        <!-- Description for first event that wil be created automatically -->
        <v-row dense v-if="rebooking === ''" class="px-3">
          <v-col cols="8">
            <v-form v-model="text_valid">
              <v-textarea
                v-model="hombData.homb_text"
                rows="2"
                required
                label="First event description rebooking"
                :rules="descriptionRules"
              >
                {{ hombData.homb_text }}
              </v-textarea>
            </v-form>
          </v-col>
        </v-row>
        <v-row class="mb-1">
          <v-divider></v-divider>
        </v-row>
        <!-- Rebooking detials: redenen, meerkosten & alternatieven -->
        <v-container>
          <ul class="ul_style">
            <li>
              <v-textarea
                v-model="hombData.homb_memo"
                rows="3"
                label="Internal memo"
              >
                {{ hombData.homb_memo }}
              </v-textarea>
            </li>                     
            <li>
              <v-textarea
                v-model="hombData.homb_alternatief"
                rows="3"
                label="Alternatives"
              >
                {{ hombData.homb_alternatief }}
              </v-textarea>
              <v-card fluid flat class="mt-0 pr-6">
                <homb_links :links="hombData.homb_alternatief_urls" @updateData="updateData" />
              </v-card>
            </li>       
          </ul>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            small
            :disabled="hombData.homb_initiatief === '' || !text_valid"
            @click="addUpdHomb()"
          >
            Save
          </v-btn>
          <v-btn color="primary" small @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <standard_dialog ref="standard_dialog" /> 
  </v-dialog>
</template>

<script>
import homb_links from '@/components/huov/ui/hokl_hosm_links.vue';
import attm_button from '@/components/huov/ui/attm_button.vue';
import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import select_initiator from '@/components/huov/ui/select_initiator.vue'
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
  props: {
    huov_encrid: String
  },
  components: {
    homb_links,
    standard_dialog,
    select_gebr,
    attm_button,
    select_initiator
  },
  data() {
    return {
      dialog: false,
      text_valid: false,
      rebooking: '',
      hombData: {},
      selections: {},    
      errorHostForceMajeure: false,
      techProblemConnection: false,
      errorHostNoForceMajeure: false,
      showExtraDropdown: false,
      errorExpert: false,
      current_reason_code: '',
      attachments: 0,
      descriptionRules: [v => !!v || "A description / value is required"]
    }
  },
  methods: {
    open_dialog(homb_encrid, rebooking) {
      this.homb_encrid = homb_encrid;
      this.rebooking = rebooking;
      this.selections = {};
      this.errorHostForceMajeure = false;
      this.techProblemConnection = false;
      this.errorHostNoForceMajeure = false;
      this.showExtraDropdown = false;
      this.errorExpert = false;
      this.current_reason_code = '';
      this.hombData = {
        huov_encrid: this.huov_encrid,
        homb_encrid: '',
        homb_gebr: '',
        homb_reden: '',
        homb_reden_urls: [],
        homb_meerkosten: '',
        homb_meerkosten_url: [],
        homb_alternatief: '',
        homb_alternatief_urls: [],
        homb_memo: '',
        homb_initiatief: '',
        homb_text: '',
        homb_omboeking_reden_code: '',
        homb_omboeking_subreden_code: '',
        homb_ext_alternatief: false,
        homb_ext_alternatief_betaling: false,        
        homb_business_days: 0,
        homb_normal_days: 0,
      }

      console.log("huov_encrid is een prop?" , this.huov_encrid);

      //if (homb_encrid !== '') {
        this.getSingleHomb();
      //} else {
        this.dialog = true;
      //}
    },
    getSingleHomb() {
      this.$axios
        .post("ares/json/ares/huov/homb/getHomb.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHomb"
          },
          getHomb: {
            huov_encrid: this.huov_encrid,
            homb_encrid: this.homb_encrid
          }
        })
        .then(res => {
          console.log(res.data)
          if (res.data.error) {
            this.$refs.standard_dialog.open('error', 'Error', res.data.error.message); 
            this.dialog = false;
          } else {
            // getHomb returns an array, with one homb (there is only one).
            this.selections = res.data.huov_homb.selections;
            if(res.data.huov_homb.homb.length !== 0) {
              this.hombData = res.data.huov_homb.homb[0]       
            }
            this.text_valid = this.rebooking !== "";
            this.dialog = true;

            this.updateReasonCode(this.hombData.homb_omboeking_reden_code);

          }
        });
    },
    updateData(data) {
      console.log("updateData", data);
      this.hombData[data.field] = data.value;
    },
    updateReasonCode(code){

      if(this.current_reason_code !== '') {
        this.hombData.homb_omboeking_subreden_code = '';
      }

      this.showExtraDropdown = true
      this.errorHostForceMajeure = false
      this.techProblemConnection = false
      this.errorHostNoForceMajeure = false
      this.errorExpert = false
      switch(code) {
        case 'errorHostForceMajeure':
          this.errorHostForceMajeure = true;
          break;
        case 'techProblemConnection':
          this.techProblemConnection = true;
          break;
        case 'errorHostNoForceMajeure':
          this.errorHostNoForceMajeure = true;
          break;          
        case 'errorExpert':
          this.errorExpert = true;
          break;                    
        default:
          this.showExtraDropdown = false;
      } 
      this.current_reason_code = code;
    },
    checkReasonCodes() {

      let msg = ''
       switch(this.hombData.homb_omboeking_reden_code) {
        case '':
          msg = 'Please select a rebooking reason';
          break;
        case 'errorHostForceMajeure':
          if (this.hombData.homb_omboeking_subreden_code === '') {
            msg = 'Please select a sub reason for host error - force majeure';
          }
          break;
        case 'techProblemConnection':
          if (this.hombData.homb_omboeking_subreden_code === '') {
            msg = 'Please select a sub reason for technical issue connection';
          }
          break;
        case 'errorHostNoForceMajeure':
          if (this.hombData.homb_omboeking_subreden_code === '') {
            msg = 'Please select a sub reason for host error - not force majeure';
          }
          break;
        case 'errorExpert': 
          if (this.hombData.homb_omboeking_subreden_code === '') {
            msg = 'Please select a sub reason for rental expert error';
          }
          break;
        default:
          msg = '';    
       }
       if(msg !== '') {
          this.$refs.standard_dialog.open('error', 'Error', msg); 
        return false;
       } else {
        return true;
       }
    },
    addUpdHomb() {

      if(!this.checkReasonCodes()){
        return;
      }
      if (this.homb_encrid === "") {
        this.$axios.post("ares/json/ares/huov/homb/addHomb2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHomb"
          },
          addHomb: this.hombData
        }).then(res => {
          if (res.data.error) {
            this.$refs.standard_dialog.open('error', 'Error', res.data.error.message); 
          } else {
            this.closeDialog();
          }
        });
      } else {
        this.$axios.post("ares/json/ares/huov/homb/updHomb2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHomb"
          },
          updHomb: this.hombData
        }).then(res => {
          if (res.data.error) {
            this.$refs.standard_dialog.open('error', 'Error', res.data.error.message); 
          } else {
            this.closeDialog();
          }
        });
      }
    },
    closeDialog() {
      this.$emit("updateData", "refresh");
      this.dialog = false;
    },
    showMailDialog(encrid) {
      this.$refs.mailDialog.open(encrid);
    },
    updateAttachments() {
      this.getSingleHomb();
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ul_style {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: 325px;
  overflow-y: auto;
}
</style>
